export enum dnDTypes {
  groupedListItem = 'grouped-list-item',
}
